import styled from "styled-components";
import infoImg from "@PUBLIC/P/images/ico/ico_spr.png";
import {LineBox, NoteBox, SubTitleWrap} from "@FRAMEWORK/ui/desktop/layout";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";

const TabListWrap = styled.div`
	padding-top: 30px;
`;

const TabContent = styled.div`
	> h3 {
		margin: 60px 0 20px;
	}
`;

const ContentWrap = styled(LineBox)<{border?: boolean}>`
	border-bottom: ${props => (props.border ? "0" : "")};
	> strong {
		font-weight: normal;
		font-family: "pr-font-medium";
		color: var(--emp-color);
	}
	+ h3 {
		margin-top: 40px;
	}
`;

const TermsContentWrap = styled.div`
	> strong {
		font-weight: normal;
		font-family: "pr-font-medium";
		color: var(--emp-color);
	}

	@media print {
		table {
			tr {
				th {
					font-size: 18px;
					line-height: 24px;
				}
				td {
					font-size: 18px;
					line-height: 24px;
				}
			}
		}
		h4 {
			font-size: 24px;
		}
		h5 {
			font-size: 22px;
		}
		h6 {
			font-size: 20px;
		}
		ul li,
		ol li {
			font-size: 18px;
		}
		strong {
			font-size: 20px;
		}
	}
`;

const BtnArea = styled.div`
	button {
		margin-top: 10px;
		margin-left: auto;
	}
`;

const BulletList = styled.ul`
	margin-top: 10px;
	> li {
		font-size: var(--default-size);
		&::before {
			top: 10px;
		}
	}
	> li + li {
		margin-top: 5px;
	}
	+ strong {
		display: block;
		margin-top: 20px;
	}
`;

const SafeBox = styled.div`
	+ p {
		margin-top: 10px;
		font-size: var(--default-size);
		&::before {
			top: 9px;
		}
	}
`;

const SafeBoxText = styled.span`
	display: block;
	margin-top: 8px;
	color: var(--emp-color);
`;

const WarningText = styled.em`
	display: inline-block;
	margin-top: 20px;
	color: var(--emp-color);
`;

const TitArea = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 60px;

	@media print {
		+ div {
			p,
			span {
				font-size: 24px;
			}
		}
	}
`;

const DayText = styled.p`
	font-size: var(--basic-size);
	color: var(--default-color);
	> span:first-of-type {
		margin-right: 8px;
	}
`;
const SelectWrap = styled.div`
	position: relative;
	display: inline-block;
	width: 240px;
`;
const TimeInfoWrap = styled.div`
	display: block;
`;

const TimeInfo = styled.p`
	position: relative;
	display: inline-block;
	line-height: 28px;
	padding-left: 28px;
	margin: 0 10px 2px 0;
	&::before {
		position: absolute;
		top: 6px;
		left: 0;
		display: inline-block;
		width: 18px;
		height: 19px;
		background: url(${infoImg}) no-repeat 0 -247px;
		vertical-align: middle;
		content: "";
	}
`;

const TimeText = styled.span`
	margin-left: 5px;
	margin-right: 5px;
	font-size: 16px;
	color: var(--emp-color);
`;

const DollerInfo = styled.div`
	position: relative;
	display: inline-block;
	line-height: 28px;
	padding-left: 28px;
	margin: 0 10px 2px 0;
	vertical-align: middle;

	&::before {
		position: absolute;
		top: 6px;
		left: 0;
		display: inline-block;
		width: 18px;
		height: 20px;
		background: url(${infoImg}) no-repeat 0 -308px;
		content: "";
	}
`;

const DollerText = styled.span`
	margin-right: 5px;
	font-size: 16px;
	color: var(--emp-color);
`;

const InfoWrap = styled.div`
	+ div {
		margin-top: 40px;
	}
`;

const TermsDownloadArea = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;

	@media print {
		h3 {
			font-size: 36px;
		}
	}
`;

const TermsBox = styled.div`
	padding: 25px 30px 30px;
	margin-top: 20px;
	border: 1px solid var(--line-color);

	@media print {
		font-size: 18px;
	}
`;

const NoteWrap = styled(NoteBox)`
	border: 1px solid var(--line-color);
	border-top: 0;
`;

const ScrollTabList = styled.ul<{isFixed?: boolean}>`
	position: sticky;
	top: 60px;
	display: flex;
	width: 100%;
	padding-top: 30px;
	background-color: #fff;
	z-index: 5;

	li {
		display: flex;
		height: 50px;
		margin-left: 1px;
		align-items: center;
		justify-content: center;
		flex: 1 1 0;
	}

	${props =>
		props.isFixed === false &&
		`
		position: static;
	`}
`;

const ScrollTabItem = styled.a<{isActive: boolean}>`
	display: flex;
	width: 100%;
	height: 100%;
	background-color: #fff;
	color: var(--emp-color);
	cursor: pointer;
	align-items: center;
	justify-content: center;
	outline: 1px solid var(--line-color);

	${props =>
		props.isActive &&
		`
		background-color: var(--emp-color);
		outline: 1px solid var(--emp-color);
		color: #fff;
	`}
`;

const ScrollContent = styled.div`
	scroll-margin: 164px;
`;

const TextButton = styled.button`
	padding-bottom: 1px;
	border-bottom: 1px solid var(--emp-color);
	background: #fff;
	font-size: var(--default-size);
	line-height: 1;
`;
const List = styled.ul`
	margin-top: 10px;
`;

const ListItem = styled.li`
	border-bottom: 1px solid var(--line-color);
`;

const ListContent = styled.div<{isActive: boolean}>`
	display: flex;
	height: 70px;
	flex-flow: row nowrap;
	flex-grow: 1;
	flex-basis: 0;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;

	${props =>
		props.isActive &&
		`
        h3 {
            
			font-family: "pr-font-medium";
        }
    `}
`;

const ListTitle = styled.div`
	display: flex;
	height: 70px;
	align-items: center;
	h5 {
		padding-left: 20px;
		font-size: var(--medium-size);
		color: var(--emp-color);
		flex-grow: 2;
		${Ellipsis(2)}
	}
`;

const MoreButton = styled.button<{isActive: boolean}>`
	padding: 0 20px;
	margin-top: -5px;
	background-color: transparent;

	&:after {
		display: block;
		width: 10px;
		height: 10px;
		border-top: 1px solid var(--emp-color);
		border-right: 1px solid var(--emp-color);
		font-size: 0px;
		transform: rotate(135deg);
		content: "";
	}

	${props =>
		props.isActive &&
		`
        margin-top: 9px;
        
        &:after {
            display: block;
            width: 10px;
            height: 10px;
            border-top: 1px solid var(--emp-color);
            border-right: 1px solid var(--emp-color);
            font-size: 0px;
            transform: rotate(-45deg);
            content: "";
        }
    `}
`;

const ListDetail = styled.div<{isActive: boolean; contentHeight: number}>`
	height: 0;
	transition: height 0.5s ease;
	opacity: 0;
	overflow: hidden;

	> div {
		display: flex;
		margin-top: 0;
	}
	${props =>
		props.isActive &&
		`
		opacity: 1;
		height: ${props.contentHeight}px;
		animation: fadeIn .8s;
	`}

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;

const SubTitleFlexWrap = styled(SubTitleWrap)`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;

	button {
		position: absolute;
		right: 0;
	}

	@media print {
		h3 {
			font-size: 36px;
		}
		+ div {
			font-size: 24px;
			line-height: 1.6;
			p,
			h5,
			h6 {
				font-size: 24px;
				line-height: 1.6;
			}
			ul li,
			ol li {
				font-size: 24px;
				line-height: 1.6;
			}
		}
	}
`;

const InsuranceLink = styled.a`
	display: flex;
	height: 50px;
	justify-content: center;
	align-items: center;
	margin-top: 10px;
	border: 1px solid var(--bl-color);
	font-size: 14px;
	color: #222;

	&:after {
		display: inline-block;
		width: 7px;
		height: 7px;
		margin-left: 5px;
		border-top: 1px solid #222;
		border-left: 1px solid #222;
		transform: rotate(135deg);
		content: "";
	}
`;

export {
	BtnArea,
	TabListWrap,
	BulletList,
	ContentWrap,
	TermsContentWrap,
	DayText,
	DollerInfo,
	DollerText,
	InfoWrap,
	SafeBox,
	SelectWrap,
	TabContent,
	TimeInfo,
	TimeInfoWrap,
	TimeText,
	TitArea,
	WarningText,
	SafeBoxText,
	TermsDownloadArea,
	TermsBox,
	NoteWrap,
	ScrollTabList,
	ScrollTabItem,
	ScrollContent,
	TextButton,
	MoreButton,
	List,
	ListContent,
	ListItem,
	ListTitle,
	ListDetail,
	SubTitleFlexWrap,
	InsuranceLink,
};
